var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.500000, 0.500000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,1 L9,1 L9,0 L8,0 L8,2.5 L7,2.5 L7,1 L4,1 L4,0 L3,0 L3,2.5 L2,2.5 L2,1 L1,1 C0.4485,1 0,1.449 0,2 L0,9.5 C0,10.051 0.4485,10.5 1,10.5 L10,10.5 C10.5515,10.5 11,10.051 11,9.5 L11,2 C11,1.4485 10.5515,1 10,1 Z M3.5,9 L1.5,9 L1.5,7 L3.5,7 L3.5,9 Z M3.5,6 L1.5,6 L1.5,4 L3.5,4 L3.5,6 Z M6.5,9 L4.5,9 L4.5,7 L6.5,7 L6.5,9 Z M6.5,6 L4.5,6 L4.5,4 L6.5,4 L6.5,6 Z M9.5,6 L7.5,6 L7.5,4 L9.5,4 L9.5,6 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a4eef266416ae20e2c6269d85b2abbc8.svg";
export { ForwardRef as ReactComponent };